import React, { useState, useEffect } from 'react';
import { API, authFetch } from '../utils/api';
import ExtraServiceChipTable from './ExtraServiceChipTable';

// ═══ 신청 폼 공용 부가서비스 칩 선택 ═══
// 대행업체를 고르면 그 업체가 등록한 부가서비스를 칩으로 보여준다. 칩을 누르면 선택 표에 담기고, 메모(선택)를
// 같이 담아 부모의 value 로 올린다(신청 전송 body 의 services 로 그대로 들어간다).
// showFee 는 대행사 스스로 신청을 등록할 때(금액을 그 자리에서 정할 수 있는 화면)만 켠다 —
// 수출업체 신청 폼(v1/v2)은 기본값 false 로 금액을 보여주지 않는다.
// 서버(GET /cancel-agencies/:id/extra-services)가 아직 배포 전이면(404/405) 조용히 숨는다.
function ExtraServicePicker({ agencyId, value, onChange, showFee }) {
  var list = value || [];
  var [services, setServices] = useState([]);
  var [unavailable, setUnavailable] = useState(false);

  useEffect(function(){
    if(!agencyId){ setServices([]); setUnavailable(false); return; }
    authFetch(API+'/cancel-agencies/'+agencyId+'/extra-services').then(function(r){
      if(r.status===404||r.status===405){ setUnavailable(true); return null; }
      if(!r.ok) throw new Error('HTTP '+r.status);
      return r.json();
    }).then(function(d){ if(d){ setServices(Array.isArray(d)?d:[]); setUnavailable(false); } }).catch(function(){ setServices([]); });
  }, [agencyId]);

  if(unavailable) return null;
  if(!agencyId) return <div style={{fontSize:12,color:'#94a3b8',marginTop:6}}>대행업체를 먼저 선택하세요.</div>;
  if(services.length===0) return null;

  var entryOf = function(id){ return list.filter(function(v){return v.serviceId===id;})[0]; };
  var toggle = function(s){
    if(entryOf(s.id)) onChange(list.filter(function(v){return v.serviceId!==s.id;}));
    else {
      var entry = {serviceId:s.id, memo:''};
      // 카탈로그에 defaultFee 가 없으면(공개 목록은 {id,name} 만) 0 표시 — 서버가 스냅샷 시 기본값을 채운다.
      if(showFee) entry.fee = s.defaultFee||0;
      if(s.kind) entry.kind = s.kind;
      onChange(list.concat([entry]));
    }
  };
  var setField = function(id, key, v){
    onChange(list.map(function(e){ if(e.serviceId!==id) return e; var n=Object.assign({},e); n[key]=v; return n; }));
  };

  var selectedIds = new Set(list.map(function(v){return v.serviceId;}));
  var rows = list.map(function(v){
    var s = services.filter(function(x){return x.id===v.serviceId;})[0];
    return { key: v.serviceId, name: s?s.name:'', fee: v.fee, memo: v.memo, kind: s?s.kind:undefined };
  });

  return (
    <div style={{marginTop:14}}>
      <label style={{display:'block',fontSize:12,fontWeight:600,color:'#374151',marginBottom:6}}>부가서비스</label>
      <ExtraServiceChipTable
        chips={services}
        selectedIds={selectedIds}
        onToggleChip={toggle}
        rows={rows}
        showFee={showFee}
        readOnly={false}
        onFeeChange={function(idx,v){setField(rows[idx].key,'fee',v);}}
        onMemoChange={function(idx,v){setField(rows[idx].key,'memo',v);}}
        onRemove={function(idx){toggle({id:rows[idx].key});}}
      />
    </div>
  );
}

export default ExtraServicePicker;
